'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var reactUtils = require('@chakra-ui/react-utils');
var ModalCloseButton = require('./ModalCloseButton.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children", "overlayProps", "contentProps", "closeButtonProps", "dividerProps", "isLoading", "onClose"];

// IMPORTANT NOTE
//
// For prop doc generation, see the `DocModal` file next to
// `Modal.stories.tsx`. Check out the comments and sync the prop(s) with
// `DocModal`.

/**
 * Modal
 *
 * @see Docs https://chakra-ui.com/components/modal
 */
var Modal = function Modal(props) {
  var children = props.children,
    overlayProps = props.overlayProps,
    contentProps = props.contentProps,
    closeButtonProps = props.closeButtonProps,
    dividerProps = props.dividerProps,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    onClose = props.onClose,
    rest = _objectWithoutProperties__default["default"](props, _excluded);

  // Extend `onClose` function to ensure it can not be executed while modal is in loading state.
  var handleClose = function handleClose() {
    if (isLoading) {
      return;
    }
    onClose();
  };

  // Check if a `Divider` should be injected.
  var withDivider = React.useMemo(function () {
    var arrayChildren = reactUtils.getValidChildren(children);
    var childrenIds = arrayChildren.map(function (child) {
      var _child$type;
      return child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.id;
    });

    // Check for occurence of ModalHeader and if ModalBody directly follows up.
    var modalHeaderOccurrence = childrenIds.indexOf('ModalHeader');
    var modalBodyOccurrence = childrenIds.indexOf('ModalBody');
    return modalHeaderOccurrence > -1 && modalBodyOccurrence === modalHeaderOccurrence + 1;
  }, [React.Children.count(children)]);
  return /*#__PURE__*/React__default["default"].createElement(react.Modal, _extends__default["default"]({}, rest, {
    onClose: handleClose
  }), /*#__PURE__*/React__default["default"].createElement(react.ModalOverlay, overlayProps), /*#__PURE__*/React__default["default"].createElement(react.ModalContent, contentProps, /*#__PURE__*/React__default["default"].createElement(ModalCloseButton.ModalCloseButton, _extends__default["default"]({
    isDisabled: isLoading
  }, closeButtonProps)), React.Children.map(children, function (child) {
    var _child$type2;
    // Check if current element is 'ModalHeader' component and `Divider` should be added after.
    var showDivider = withDivider && (child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.id) === 'ModalHeader';
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, child, showDivider && /*#__PURE__*/React__default["default"].createElement(react.Divider, _extends__default["default"]({
      mb: 3
    }, dividerProps)));
  })));
};
Modal.displayName = 'Modal';
exports.Modal = Modal;